import { render, staticRenderFns } from "./PublicityEditor.vue?vue&type=template&id=0239b862&scoped=true"
import script from "./PublicityEditor.vue?vue&type=script&lang=js"
export * from "./PublicityEditor.vue?vue&type=script&lang=js"
import style0 from "./PublicityEditor.vue?vue&type=style&index=0&id=0239b862&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239b862",
  null
  
)

export default component.exports